import api from '../api';

/**
 * 邮件服务
 * 提供发送邮件相关的API调用
 */
export default {
  /**
   * 发送购买请求邮件
   * @param {Object} emailData - 邮件数据
   * @param {string} emailData.subject - 邮件主题
   * @param {string} emailData.body - 邮件内容
   * @returns {Promise} - 返回API请求的Promise
   */
  sendPurchaseEmail(emailData) {
    return api.post('/api/purchase', emailData);
  },
  
  /**
   * 发送联系我们邮件
   * @param {Object} contactData - 联系表单数据
   * @returns {Promise} - 返回API请求的Promise
   */
  sendContactEmail(contactData) {
    return api.post('/api/contact-us', contactData);
  }
};